import React from "react"
import { withStyles } from '@weareroam/cake-ui-v1/styles'
import { Transition as ReactTransition } from "react-transition-group"
import { historyExitingEventType, timeout } from "../../gatsby-browser"

import Link from 'gatsby-link'
import { navigateTo } from 'gatsby-link'
import storageHelper from '../utils/storageHelper'
import { isWindow } from '../utils/formatting'

const styles = theme => ({
    entering: {
      opacity: 0,
    },
    entered: {
      transition: `opacity ${timeout}ms ease-in-out`,
      opacity: 1,
    },
    exiting: {
      transition: `opacity ${timeout}ms ease-in-out`,
      opacity: 0,
    },
    exited: {
        opacity: 0,
    },
})

class Transition extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            exiting: false,
            showContent: false,
        }
        this.listenerHandler = this.listenerHandler.bind(this)
    }

    listenerHandler(event) {
        this.setState({ exiting: true })
    }

    componentWillMount() {
        if(!storageHelper().getFromStorage('accessToken') && !this.props.root) {
            if (isWindow()) {
                navigateTo({
                    pathname: '/',
                    data: { fromRoot: true }
                })
            }
        } else {
            this.setState({ showContent: true })
        }
    }

    componentDidMount() {
        window.addEventListener(historyExitingEventType, this.listenerHandler)
    }

    componentWillUnmount() {
        window.removeEventListener(historyExitingEventType, this.listenerHandler)
    }

    static componentWillReceiveProps({ exiting }) {
        if (exiting) {
            return { exiting: false }
        }
        return null
    }

    getClassName = (status) => {
        const { root, classes } = this.props

        // Disable entry animation on root pages to avoid
        // flash of content while the javascript is loading
        return status === 'entering' && root ? "" : classes[status]
    }

    render() {
        const transitionProps = {
            timeout: {
                enter: 0,
                exit: timeout,
            },
            appear: true,
            in: !this.state.exiting,
        }

        return this.state.showContent ? (
            <ReactTransition {...transitionProps}>
                {status => (
                    <div className={this.getClassName(status)}>
                        {this.props.children}
                    </div>
                )}
            </ReactTransition>
        ) : null
    }
}

export default withStyles(styles)(Transition)



// WEBPACK FOOTER //
// ./src/components/Transition.js